<template>
    <div class="container">
        <Title text="Nuova Bolla" :backArrow="true" :backVue="'pratica/' + nome_pratica + '~' + id_pratica" />
        <b-alert :show="no_file_alert" variant="danger">Per favore caricare un file.</b-alert>
        <div class="form-container">
            <b-form @submit="submit">
                <!-- First row -->
                <div class="d-flex justify-content-between align-items-center form-row">
                    <b-form-group label="Nome di riferimento della bolla" label-for="nome_bolla" class="form-group">
                        <b-form-input
                            id="nome_bolla"
                            v-model="nome_bolla"
                            required
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                    <div class="pdf-button-container">
                        <ButtonSecondary type="button" :text="'Carica Pdf'" :file_input="true" v-model="file" @fileUpload="fileUploaded($event)" class="pdf-button" />
                    </div>
                </div>
                <!-- / First row -->
                <!-- Second row -->
                <div class="d-flex justify-content-between align-items-center form-row">
                    <b-form-group label="Data della bolla" label-for="data" class="form-group">
                        <b-form-input
                            id="data"
                            v-model="data_bolla"
                            required
                            type="date"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <!-- / Second row -->
                <div class="submit-button-container">
                    <b-overlay
                        :show="busy"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="success"
                        class="d-inline-block"
                    >
                        <ButtonPrimary :text="'Carica'" :front_arrow="true" class="submit-button" />
                    </b-overlay>
                </div>
            </b-form>
        </div>
    </div>
</template>

<script>
import Title from '@/components/Title.vue'
import ButtonPrimary from '@/components/Button-Primary.vue'
import ButtonSecondary from '@/components/Button-Secondary.vue'
import { mixins } from "@/mixins";

export default {
    name: "CreateBolla",
    data () {
        return {
            id_pratica: this.$route.params.id,
            nome_bolla: '',
            nome_pratica: this.$route.params.name,
            data_bolla: new Date().toJSON().slice(0,10),
            file: null,
            no_file_alert: false,
            busy: false
        }
    },
    components: {
        Title,
        ButtonPrimary,
        ButtonSecondary
    },
    mixins: [mixins],
    methods: {
        fileUploaded: function(file) {
            this.file = file;
            this.no_file_alert = false;
        },
        submit: function (evt) {
            evt.preventDefault()
            if(this.file == null){
                this.no_file_alert = true;
                return
            }
            this.busy = true;
            let formData = new FormData();
            formData.append('pdf_url', this.file);
            formData.append('nome', this.nome_bolla);
            formData.append('pratica', this.$apibase + '/api/pratica/' + this.id_pratica + '/');
            formData.append('data_bolla', this.data_bolla);
            formData.append('verificata', false);
            this.$axios
                .post(this.$apibase + '/api/bolle/', 
                    formData,
                    {
                        headers: {
                            Authorization:"JWT " + localStorage.getItem('access_token'),
                            'Content-Type': 'multipart/form-data;',
                        }
                    }
            )
                .then(() => {
                    this.$axios
                    .post(this.$apibase + '/api/pratica/update_ultima_bolla/',
                        {
                            'data': this.data_bolla,
                            'id_pratica': this.id_pratica
                        },
                        {
                            headers: {
                                Authorization:"JWT " + localStorage.getItem('access_token'),
                            }
                        }
                    )
                    .then(()=>{
                        this.$store.dispatch('setAlert', {message: "Bolla \"" + this.nome_bolla + "\" è stata aggiunta con successo.", type: 'success'});
                        this.$router.push('/pratica/' + this.nome_pratica + '~' + this.id_pratica);  
                    })
                    .catch( e => {
                        if (e.response.status == 403)
                            this.logout();
                        else
                            alert(e.response);
                    })
                })
                .catch( e => {
                    if (e.response.status == 403)
                        this.logout();
                    else
                        alert(e.response);
                })
        }
    }    
    
}
</script>

<style scoped>
    .container {
        width: 70%;
        max-width: 800px;
    }
    .form-container{
        padding-top: 10px;
        text-align: left;
    }
    .form-group{
        width: 300px;
    }
    .form-row{
        padding-top:30px;
    }
    .submit-button-container {
        margin-top: 80px;
    }
    .submit-button {
        height: 40px;
        width: 120px;
    }
    .pdf-button-container {
        width: 200px;
    }
    .pdf-button {
        height: 40px;
    }
</style>
